<div class="table-sio" [ngClass]="{'modal-simple-message': (class==false) }">
    <ng-container *ngIf="error">
        <div class="row-sio">
            <div class="padding-txt">
                <label class="font-algoSalioMal">¡UPS!, ALGO SALIO MAL</label><br>
            </div>
        </div>
    </ng-container>
    <div class="row-sio" *ngIf="srcImage && srcImage != ''">
        <div class="cell-sio py-10x px-20x align-bottom text-center">
            <img [src]="srcImage" width="widthImage" height="heightImage" />
        </div>
    </div>
    <div class="row-sio" *ngIf="message && message != ''">
        <div class="cell-sio py-10x px-20x align-bottom text-center">
            <h5 [innerHtml]="message"></h5>
        </div>
    </div>
    <ng-container *ngIf="error && !mostrarSoloEncabezadoError">
        <div class="row-sio w-100" *ngIf="error">
            <div class="cell-sio w-100">
                <div class="padding-txt">
                    <label class="font-marcameTxt">Nos puedes marcar</label><br>
                </div>
                <div class="padding-txt">
                    <label class="font-numero">55442 46837</label><br>
                </div>
                <div class="padding-txt" *ngIf="llamar">
                    <label class="font-marcameTxt"> o te podemos marcar</label>
                </div>
            </div>
        </div>
        <ng-container [ngClass]="{'display-block': llamar, 'display-none': !llamar}">
            <div class="row-sio w-100">
                <div class="cell-sop w-100 d-flex justify-content-center">
                    <mat-form-field class="aling">
                        <input matInput id="btnTelefono" placeholder="Teléfono/Celular" TypeValidation="number"
                            maxlength="10" [(ngModel)]="telefono" />
                    </mat-form-field>
                </div>
            </div>
            <div class="row-sio w-100">
                <div class="cell-sop w-100">
                    <mat-dialog-actions>
                        <button mat-flat-button class="m-auto" [color]="styleCocheSeguro?.colorBtn" id="btnMarcame" [disabled]="valida()" (click)="obtenerAyuda()">Márcame</button>
                    </mat-dialog-actions>
                </div>
            </div>
        </ng-container>
    </ng-container>
    <div class="row-sio" *ngIf="simpleModal===1">
        <div class="cell-sio py-10x px-20x">
            <mat-radio-group aria-labelledby="confirmar-radio-group-label" class="confirmar-radio-group"
                [(ngModel)]="elegir">
                <mat-radio-button class="confirmar-radio-button" [value]="capturaste"><span class="font-600">Tu
                        capturaste</span><br />{{capturaste}}</mat-radio-button>
                <mat-radio-button class="confirmar-radio-button" [value]="recomendacion"><span
                        class="font-600">Recomendación</span><br />{{recomendacion}}</mat-radio-button>
            </mat-radio-group>
        </div>
    </div>
    
    <ng-container *ngIf="btnOrder=='default'; else other">
        <div *ngIf="!btnConMismoEstilo()" class="row-sio">
            <div class="cell-sio py-10x px-20x align-bottom" [ngClass]="classContainerAccion && classContainerAccion != '' ? classContainerAccion : 'text-right'">
                <ng-container *ngIf="accion && accion != ''">
                    <button mat-flat-button [color]="styleCocheSeguro?.colorBtn" [ngClass]="classAccion != '' ? classAccion : ''"
                        (click)="modalRef.close(true)">{{accion}}</button>
                </ng-container>
                <ng-container *ngIf="cancel && cancel != ''">
                    <button mat-button class="ml-5x" (click)="modalRef.close(false)">{{cancel}}</button>
                </ng-container>
            </div>

        </div>
        <div *ngIf="btnConMismoEstilo()"  class="row">
            <div class="d-flex flex-column flex-md-row  justify-content-md-around my-5 w-100">
                <button mat-flat-button [color]="styleCocheSeguro?.colorBtn" [ngClass]="classAccion != '' ? classAccion : ''"
                (click)="modalRef.close(true)">{{accion}}</button>
            <button mat-flat-button [color]="styleCocheSeguro?.colorBtn" [ngClass]="classAccion != '' ? classAccion : ''"
                (click)="modalRef.close(false)">{{cancel}}</button>
                <mat-icon *ngIf="mostrarTooltip" class="icoInfo" #tooltip="matTooltip" matTooltipClass="tool-tip" 
                matTooltip={{textoTooltip}} matTooltipPosition='right'>info</mat-icon>
            </div>

        </div>
    </ng-container>
    <ng-template #other>
        <ng-container *ngIf="accion && accion != ''">
            <div class="row-sio">
                <div class="cell-sio py-10x px-20x text-left">
                    <button tabindex="-1" mat-flat-button [color]="styleCocheSeguro?.colorBtn" class="w-100" (click)="modalRef.close(1)">
                        <mat-icon class="mat-icon">attach_money</mat-icon>
                        <span class="mat-button-wrapper">{{accion}}</span>
                    </button>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="cancel && cancel != ''">
            <div class="row-sio">
                <div class="cell-sio py-10x px-20x text-left">

                    <button tabindex="-1" mat-flat-button [color]="styleCocheSeguro?.colorBtn" class="w-100" (click)="modalRef.close(2)">
                        <mat-icon class="mat-icon">event</mat-icon>
                        <span class="mat-button-wrapper">{{cancel}}</span>
                    </button>
                </div>
            </div>
        </ng-container>
    </ng-template>
</div>